export default __webpack_public_path__ + "static/media/girar_celular_por.19d382fe.jpg";